import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=18c136b4"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18c136b4')) {
      api.createRecord('18c136b4', component.options)
    } else {
      api.reload('18c136b4', component.options)
    }
    module.hot.accept("./Dialog.vue?vue&type=template&id=18c136b4", function () {
      api.rerender('18c136b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/deposit/components/Dialog.vue"
export default component.exports